import { useZoneContext } from 'context/ZoneContext';
import { PathSelectionOptionValueType } from '../../../../../../types';
import { Path } from '../Path/Path';

export const PathSelectionIcon = ({
    Selected,
    Unselected,
    value,
    testId,
    path,
    onClick
}: {
    Selected: React.FunctionComponent<React.ComponentProps<'svg'> & { title?: string }>;
    Unselected: React.FunctionComponent<React.ComponentProps<'svg'> & { title?: string }>;
    value: PathSelectionOptionValueType;
    testId?: string;
    path: Path;
    onClick: (value: PathSelectionOptionValueType) => void;
}) => {
    const { scale } = useZoneContext();
    const size = Math.min(60, 60 / scale);
    return path.isSelected === value ? (
        <Unselected data-testid={testId} onClick={() => onClick(value)} width={size} height={size} />
    ) : (
        <Selected data-testid={testId} onClick={() => onClick(value)} width={size} height={size} />
    );
};
